import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { SidebarProvider, SidebarInset } from './components/Sidebar';
import { ClassificationBanner } from './components/dashboard/ClassificationBanner';
import { LiveAlertTicker } from './components/dashboard/LiveAlertTicker';
import { TopHeader } from './components/dashboard/TopHeader';
import { AppSidebar } from './components/dashboard/AppSidebar';
import { FooterStrip } from './components/dashboard/FooterStrip';
import { Toaster } from './components/Sonner';
import { Login } from './pages/Login';
import { ExecutiveDashboard } from './pages/ExecutiveDashboard';
import { DailyBrief } from './pages/DailyBrief';
import { AiAnalyst } from './pages/AiAnalyst';
import { HotIssue } from './pages/HotIssue';
import { Sentiment } from './pages/Sentiment';
import { ShadowNarrative } from './pages/ShadowNarrative';
import { PublicGrievance } from './pages/PublicGrievance';
import { ThreatIntel } from './pages/ThreatIntel';
import { DigitalEscort } from './pages/DigitalEscort';
import { VisitIntel } from './pages/VisitIntel';
import { Deepfake } from './pages/Deepfake';
import { ActorNetwork } from './pages/ActorNetwork';
import { BotDetection } from './pages/BotDetection';
import { ForeignInfluence } from './pages/ForeignInfluence';
import { Ipoleksosbudhankam } from './pages/Ipoleksosbudhankam';
import { Astagatra } from './pages/Astagatra';
import { Geospatial } from './pages/Geospatial';
import { PolicyImpact } from './pages/PolicyImpact';
import { ProgramWarRoom } from './pages/ProgramWarRoom';
import { CommandTasking } from './pages/CommandTasking';
import { ResponseRecommender } from './pages/ResponseRecommender';
import { LegalEvidence } from './pages/LegalEvidence';
import { PlatformReporting } from './pages/PlatformReporting';
import { CaseManagement } from './pages/CaseManagement';
import { Workbench } from './pages/Workbench';
import { Reports } from './pages/Reports';
import { MinistryMapping } from './pages/MinistryMapping';
import { NarrativeCalendar } from './pages/NarrativeCalendar';
import { AiConfiguration } from './pages/AiConfiguration';
import { WarRoom } from './pages/WarRoom';
import { HybridThreats } from './pages/HybridThreats';
import { CrisisSimulation } from './pages/CrisisSimulation';
import { PresidentialDigitalTwin } from './pages/PresidentialDigitalTwin';
import { Settings } from './pages/Settings';
import { Profile } from './pages/Profile';
import { Help } from './pages/Help';
import { ModulePlaceholder } from './pages/ModulePlaceholder';
function isAuthed() {
  try {
    return !!localStorage.getItem('gs_auth');
  } catch {
    return false;
  }
}
function ProtectedShell() {
  const loc = useLocation();
  if (!isAuthed()) return <Navigate to="/login" replace state={{
    from: loc.pathname
  }} data-id="element-0" />;
  return <div className="min-h-screen bg-background text-foreground selection:bg-primary/20" data-id="element-1">
      <SidebarProvider defaultOpen={true} data-id="element-2">
        <AppSidebar data-id="element-3" />
        <SidebarInset className="bg-background flex flex-col min-h-svh min-w-0 overflow-x-hidden" data-id="element-4">
          <ClassificationBanner data-id="element-5" />
          <LiveAlertTicker data-id="element-6" />
          <TopHeader data-id="element-7" />
          <main className="flex-1 overflow-y-auto overflow-x-hidden min-w-0 p-3 sm:p-4 lg:p-6 scrollbar-thin scrollbar-thumb-border scrollbar-track-transparent" data-id="element-8">
            <div className="min-w-0 w-full" data-id="element-9">
              <Outlet data-id="element-10" />
              <FooterStrip data-id="element-11" />
            </div>
          </main>
        </SidebarInset>
      </SidebarProvider>
      <Toaster theme="light" position="bottom-right" richColors closeButton data-id="element-12" />
    </div>;
}
export function App() {
  useEffect(() => {
    document.documentElement.classList.remove('dark');
  }, []);
  return <BrowserRouter data-id="element-13">
      <Routes data-id="element-14">
        <Route path="/login" element={<Login data-id="element-16" />} data-id="element-15" />

        <Route path="/" element={<ProtectedShell data-id="element-18" />} data-id="element-17">
          <Route index element={<Navigate to="/dashboard" replace data-id="element-20" />} data-id="element-19" />
          <Route path="dashboard" element={<ExecutiveDashboard data-id="element-22" />} data-id="element-21" />
          <Route path="war-room" element={<WarRoom data-id="element-24" />} data-id="element-23" />

          <Route path="daily-brief" element={<DailyBrief data-id="element-26" />} data-id="element-25" />
          <Route path="ai-analyst" element={<AiAnalyst data-id="element-28" />} data-id="element-27" />

          <Route path="hot-issue" element={<HotIssue data-id="element-30" />} data-id="element-29" />
          <Route path="sentiment" element={<Sentiment data-id="element-32" />} data-id="element-31" />
          <Route path="shadow-narrative" element={<ShadowNarrative data-id="element-34" />} data-id="element-33" />
          <Route path="public-grievance" element={<PublicGrievance data-id="element-36" />} data-id="element-35" />

          <Route path="threat-intel" element={<ThreatIntel data-id="element-38" />} data-id="element-37" />
          <Route path="hybrid-threats" element={<HybridThreats data-id="element-40" />} data-id="element-39" />
          <Route path="digital-escort" element={<DigitalEscort data-id="element-42" />} data-id="element-41" />
          <Route path="visit-intel" element={<VisitIntel data-id="element-44" />} data-id="element-43" />
          <Route path="deepfake" element={<Deepfake data-id="element-46" />} data-id="element-45" />

          <Route path="actor-network" element={<ActorNetwork data-id="element-48" />} data-id="element-47" />
          <Route path="bot-detection" element={<BotDetection data-id="element-50" />} data-id="element-49" />
          <Route path="foreign-influence" element={<ForeignInfluence data-id="element-52" />} data-id="element-51" />

          <Route path="ipoleksosbudhankam" element={<Ipoleksosbudhankam data-id="element-54" />} data-id="element-53" />
          <Route path="astagatra" element={<Astagatra data-id="element-56" />} data-id="element-55" />
          <Route path="geospatial" element={<Geospatial data-id="element-58" />} data-id="element-57" />
          <Route path="policy-impact" element={<PolicyImpact data-id="element-60" />} data-id="element-59" />
          <Route path="program-war-room" element={<ProgramWarRoom data-id="element-62" />} data-id="element-61" />

          <Route path="command-tasking" element={<CommandTasking data-id="element-64" />} data-id="element-63" />
          <Route path="response-recommender" element={<ResponseRecommender data-id="element-66" />} data-id="element-65" />
          <Route path="crisis-simulation" element={<CrisisSimulation data-id="element-68" />} data-id="element-67" />

          <Route path="legal-evidence" element={<LegalEvidence data-id="element-70" />} data-id="element-69" />
          <Route path="platform-reporting" element={<PlatformReporting data-id="element-72" />} data-id="element-71" />
          <Route path="case-management" element={<CaseManagement data-id="element-74" />} data-id="element-73" />

          <Route path="workbench" element={<Workbench data-id="element-76" />} data-id="element-75" />
          <Route path="reports" element={<Reports data-id="element-78" />} data-id="element-77" />
          <Route path="ministry-mapping" element={<MinistryMapping data-id="element-80" />} data-id="element-79" />
          <Route path="narrative-calendar" element={<NarrativeCalendar data-id="element-82" />} data-id="element-81" />
          <Route path="ai-config" element={<AiConfiguration data-id="element-84" />} data-id="element-83" />
          <Route path="digital-twin" element={<PresidentialDigitalTwin data-id="element-86" />} data-id="element-85" />

          <Route path="settings" element={<Settings data-id="element-88" />} data-id="element-87" />
          <Route path="profile" element={<Profile data-id="element-90" />} data-id="element-89" />
          <Route path="help" element={<Help data-id="element-92" />} data-id="element-91" />

          <Route path="*" element={<ModulePlaceholder title="404 Not Found" description="Halaman tidak ditemukan." data-id="element-94" />} data-id="element-93" />
        </Route>
      </Routes>
    </BrowserRouter>;
}